// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__28clD","approved":"Status_approved__feh-d","rejected":"Status_rejected__299kO","expired":"Status_expired__FSdoq","label":"Status_label__5BQD-"};